import {Paper, PaperProps, styled} from "@mui/material";


export const DashboardRowContainer = styled("div")(() => ({
    width: '100%',
    display: "flex",
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '1rem'
}));

export const PieContainer = styled((props: PaperProps) => <Paper {...props} elevation={0}/>)(() => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: 'center',
    alignItems: 'center',
    gap: '2rem',
    padding: '1rem',
    width: '100%',
    minHeight: '367px'
}));

export const BarContainer = styled((props: PaperProps) => <Paper {...props} elevation={0}/>)(() => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: 'center',
    alignItems: 'center',
    gap: '2rem',
    padding: '1rem',
    width: '100%',
    height: '367px',

    '& .recharts-text': {
        fill: '#CFCFE0'
    },
    '& .recharts-cartesian-axis-tick-line': {
        fill: '#CFCFE0',
        stroke: 'unset'
    },
    '& .recharts-surface': {
        overflow: 'visible'
    }
}));

export const TotalCard = styled((props: PaperProps) => <Paper {...props} elevation={0}/>)(() => ({
    display: "flex",
    flexDirection: "column",
    gap: '1rem',
    padding: '1rem',
    width: '100%'
}));

export const TotalCardTitle = styled("span")(() => ({
    width: '100%',
    fontSize: '1rem',
    fontWeight: 600,
    display: 'flex',
    justifyContent: 'center',
}));

export const TotalCardValue = styled("span")(() => ({
    color: '#087E38',
    fontSize: '1.8rem',
    display: 'flex',
    justifyContent: 'center',
}));
